import { useState, useCallback } from 'react'
import axios from '../lib/axios'

interface HistoryDataPoint {
  xValue: string
  yValue: number
}

interface HistoryResponse {
  data: HistoryDataPoint[]
  lastUpdated: string
}

export const useOverallPerformanceHistory = () => {
  const [historyData, setHistoryData] = useState<HistoryDataPoint[]>([])
  const [lastUpdated, setLastUpdated] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchHistoryData = useCallback(async (framework: string) => {
    setLoading(true)
    setError(null)

    try {
      const response = await axios.post('/api/v3/cpis/overall_performance_history', {
        timePeriod: '1m',
        framework
      })

      if (response.status === 201) {
        const data: HistoryResponse = response.data
        setHistoryData(data.data || [])
        setLastUpdated(data.lastUpdated || '')
      }
    } catch (err) {
      console.error('Failed to fetch performance history:', err)
      setError('Failed to load performance history')
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    historyData,
    lastUpdated,
    loading,
    error,
    fetchHistoryData
  }
}
